export const mainnet = {
  chainId: "0x63564c40",
  chainName: "Harmony",
  nativeCurrency: {
    name: "ONE",
    symbol: "ONE",
    decimals: 18,
  },
  rpcUrls: ["https://api.harmony.one"],
  blockExplorerUrls: ["https://explorer.harmony.one"],
};

export const testnet = {
  chainId: "0x6357d2e0",
  chainName: "Harmony Testnet",
  nativeCurrency: {
    name: "ONE",
    symbol: "ONE",
    decimals: 18,
  },
  rpcUrls: ["https://api.s0.b.hmny.io"],
  blockExplorerUrls: ["https://explorer.testnet.one"],
};

export const devnet = {
  chainId: "0x635ae020",
  chainName: "Harmony Devnet",
  nativeCurrency: {
    name: "ONE",
    symbol: "ONE",
    decimals: 18,
  },
  rpcUrls: ["https://api.s0.ps.hmny.io"],
  blockExplorerUrls: ["https://explorer.ps.hmny.io"],
};

export const mumbai = {
  chainId: "0x13881",
  chainName: "Polygon mumbai",
  nativeCurrency: {
    name: "MATIC",
    symbol: "MATIC",
    decimals: 18,
  },
  rpcUrls: [
    "https://polygon-mumbai.g.alchemy.com/v2/-D6q_IdN2AiCh4k44LnX3R8CJnoOv4jG",
  ],
  blockExplorerUrls: ["https://mumbai.polygonscan.com/"],
};
